var gql = require("graphql-tag");

const SEO_QUERY = gql`
    query Seo($key: String!, $query: String) {
        seoV2(key: $key, query: $query) {
            id
            title
            description
            keywords
            h1
            h1After
            main_text
            ttltext
            aboutWETitle
            aboutWEText
            faq {
                question
                answer
            }
        }
    }
`;

export default SEO_QUERY;
